const GET_USER_PROFILE_DATA: string = 'GET_USER_PROFILE_DATA';
const UPDATE_USER_PUBKEY: string = 'UPDATE_USER_PUBKEY';
const SAVE_ACCESS_TOKEN: string = 'SAVE_ACCESS_TOKEN';
const SAVE_AID: string = 'SAVE_AID';

export { GET_USER_PROFILE_DATA, SAVE_ACCESS_TOKEN, UPDATE_USER_PUBKEY, SAVE_AID };
